<template>
  <div>
    <v-toolbar class="toolbar-element" light absolute flat height="90em">
      <v-toolbar-title class="toolbar-title">{{ title }} {{ playerName }}</v-toolbar-title>
    </v-toolbar>
    <div v-if="loading" class="spacing-top">
      <v-flex offset-xs5 pa-5>
        <v-progress-circular :size="100" :width="5" color="primary" indeterminate></v-progress-circular>
      </v-flex>
    </div>
    <div v-else class="spacing-top">
      <TerminationCreateDialog ref="termination"></TerminationCreateDialog>
      <v-card class="custom-font-regular">
        <v-card dark flat>
          <v-btn absolute bottom class="add-button" dark right fab @click="newAddenda" v-if="canAddAddendum()">
            <v-tooltip bottom>
              <v-icon slot="activator">add</v-icon>
              <span>Agregar adenda</span>
            </v-tooltip>
          </v-btn>
          <v-container ma-0>
            <v-card-actions>
              <div>
                <v-chip color="pink" label small text-color="white" right>{{ 'CONTRATO '+contract.contractType.toUpperCase() }}</v-chip>
              </div>
              <v-divider vertical class="mx-5"></v-divider>
              <ContractViewToolbarItem text="Contrato" :value="contract.status"></ContractViewToolbarItem>
              <ContractViewToolbarItem text="Inicio" :value="contract.startDate"></ContractViewToolbarItem>
              <ContractViewToolbarItem text="Fin" :value="contract.endDate"></ContractViewToolbarItem>
              <v-divider vertical class="mx-5"></v-divider>
              <div>
                <v-layout column>
                  <v-btn :href="contract.asset.url" target="_blank" small color="primary" class="action-button">
                    <span>Acceder</span>
                    <v-icon right small>open_in_new</v-icon>
                  </v-btn>
                  <template v-if="$store.getters.isClubRole">
                    <v-btn @click="showTerminationDialog" small color="grey darken-1" class="mt-1 ml-0 action-button" :disabled="saving || isEnded">
                      <span>Finalizar</span>
                      <v-icon right small>work_off</v-icon>
                    </v-btn>
                  </template>
                </v-layout>
              </div>
            </v-card-actions>
          </v-container>
        </v-card>
        <v-card-text class="pt-0">
          <v-timeline align-top dense>
            <ContractViewTimelineItemCreated :contract="contract"></ContractViewTimelineItemCreated>
            <template v-for="(item, index) in record">
              <template v-if="item.hasOwnProperty('type')">
                <ContractViewTimelineItemTermination :key="'t'+item.pk" :termination="item"></ContractViewTimelineItemTermination>
              </template>
              <template v-else-if="item.hasOwnProperty('asset')">
                <ContractViewTimelineItemAddendum :key="'a'+item.pk" :addendum="item"></ContractViewTimelineItemAddendum>
              </template>
              <template v-else>
                <ContractViewTimelineItemObservation :key="'o'+item.pk" :observation="item" :contract="contract"
                                                     :last-item="index === (record.length-1)">
                </ContractViewTimelineItemObservation>
              </template>
            </template>
            <ContractViewTimelineItemClosed :close-date="contract.closeDate"
                                            v-if="isEnded && !hasEndedObservation"></ContractViewTimelineItemClosed>
          </v-timeline>
        </v-card-text>
        <div v-if="canCorrect" class="pb-4">
          <v-divider class="mx-4 mt-3 mb-1"></v-divider>
          <ContractViewObservationCreate @newObservation="fetchData" :contract-type="contract.contractType"
                                         :contract="contract"></ContractViewObservationCreate>
        </div>
      </v-card>
      <GoBackButton/>
    </div>
  </div>
</template>

<script>
import TerminationCreateDialog from '../components/TerminationCreateDialog'
import ContractViewObservationCreate from '../components/ContractViewObservationCreate'
import ContractViewToolbarItem from '../components/ContractViewToolbarItem'
import ContractViewTimelineItemAddendum from '../components/ContractViewTimelineItemAddendum'
import ContractViewTimelineItemObservation from '../components/ContractViewTimelineItemObservation'
import ContractViewTimelineItemClosed from '../components/ContractViewTimelineItemClosed'
import ContractViewTimelineItemCreated from '../components/ContractViewTimelineItemCreated'
import ContractViewTimelineItemTermination from '../components/ContractViewTimelineItemTermination'
import GoBackButton from '../../../common/ui/GoBackButton'
import Constants from '../../../common/constants'

const VERIFICADO = 'Verificado'
const FINALIZADO = 'Finalizado'
const PENDING = 'Pendiente'

export default {
  components: {
    ContractViewTimelineItemObservation,
    ContractViewTimelineItemAddendum,
    TerminationCreateDialog,
    ContractViewObservationCreate,
    ContractViewToolbarItem,
    ContractViewTimelineItemClosed,
    ContractViewTimelineItemCreated,
    ContractViewTimelineItemTermination,
    GoBackButton
  },

  data () {
    return {
      saving: false,
      loading: true,
      contract: {}
    }
  },

  computed: {
    record () {
      return [...this.contract.addenda, ...this.contract.observations, ...this.contract.terminations].sort((a, b) => {
        return this.compareRecordElements(a, b)
      })
    },
    playerName () {
      if (this.loading) return ''
      return this.contract.player.firstName + ' ' + this.contract.player.lastName
    },
    isEnded () {
      return this.contract.status === FINALIZADO
    },
    hasEndedObservation () {
      let lastItem = this.record.slice(-1)[0]
      return lastItem && (lastItem.status === Constants.CONTRACT_ENDED)
    },
    canCorrect () {
      return this.$store.getters.isSafRole && this.contract.status === PENDING
    },
    title () {
      if (this.loading) return ''
      let title = (this.contract.player.rol === Constants.PLAYER_ROL_JUGADOR) ? 'Contrato del Jugador' : 'Contrato de Cuerpo Técnico de '
      return title
    }
  },

  methods: {
    fetchData () {
      this.loading = true
      this.axios
        .get(`contract/${this.$route.params.id}`)
        .then(response => {
          this.contract = response.data
          this.loading = false
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    newAddenda () {
      this.$router.push({ name: 'nuevaAdenda', params: { id: this.$route.params.id, contractEndDate: this.contract.endDate } })
    },
    showTerminationDialog () {
      this.$refs.termination.showDialog()
    },
    canAddAddendum () {
      let isVerified = (this.contract.status === VERIFICADO)
      return this.$store.state.permissions.canAddAdendas && isVerified && (this.contract.contractType !== Constants.CONTRACT_TYPE_AFA)
    },
    getDate (dateFromAPI) {
      const [day, month, year, time] = dateFromAPI.split(/[\s/ ]+/)
      return new Date(`${year}-${month}-${day} ${time}`)
    },
    compareRecordElements (a, b) {
      let aDate = a.created
      let bDate = b.created
      return (this.getDate(aDate) < this.getDate(bDate)) ? -1 : 1
    }
  },
  created () {
    this.fetchData()
  }
}
</script>

<style scoped>
.spacing-top {
  margin-top: 6em !important;
}
.action-button {
  width: 130px;
}
</style>
